"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIRegisterExtensions = void 0;
function isIRegisterExtensions(value) {
    return "register" in value;
}
exports.isIRegisterExtensions = isIRegisterExtensions;
//# sourceMappingURL=IRegisterExtensions.js.map